import React, { useMemo } from 'react';
import classNames from 'classnames';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';
import type { GenericField } from '@uncinc/react-drupal-core/types';

import type { EmploymentType } from '../../../../../types/uncinc_profile/nodes';
import type { SearchAllContentVacancyHit as Type } from '../../../../SearchAllContent/types';
import { taxonomyTagElasticMapper } from '../../../../Tags/taxonomyTagMapper';
import { translateEmploymentTypes } from '../../../../../helpers/translatedEmploymentTypes';

import Card from '../../../../Card';
import { DEFAULT_LANGUAGE } from '../../../../../config/constants';

import './style.scss';

const MetaSearchVacancyHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('MetaSearchHit', 'MetaSearchVacancyHit');

  const translatedEmploymentTypes = useMemo(() => (
    translateEmploymentTypes(
      hit.vacancy_employment_types?.map(
        (vacancy_employment_types) => ({ value: vacancy_employment_types }),
      ) as unknown as GenericField<EmploymentType>[],
      hit.langcode[0] || DEFAULT_LANGUAGE,
    )
  ), [hit.vacancy_employment_types, hit.langcode]);

  return (
    <Card className={classes}>
      <Card.Content>
        <div className="MetaSearchVacancyHit__text-wrapper">
          <div className="Card__content__body">
            <Card.Link link={hit.url[0]}>
              <Card.Title title={hit.page_title[0]} />
            </Card.Link>

            <Card.Subtitle
              subtitle={(
                <p className="u-truncate--3">
                  {hit.body_summarized?.[0] ? (
                    hit.body_summarized[0]
                  ) : (
                    hit.body?.[0]
                  )}
                </p>
              )}
            />
          </div>

          <div className="Card__content__metadata-wrapper">
            <div className="Card__content__metadata">
              {hit.vacancy_function_name?.[0] && (
                <div className="MetaSearchVacancyHit__functions">
                  <Card.Tags tags={taxonomyTagElasticMapper(hit.vacancy_function_name, 'vacancy_function_name')} />
                </div>
              )}
              {hit.vacancy_locations_name?.[0] && (
                <div className="MetaSearchVacancyHit__locations">
                  <Icon name="location_on" flair="outlined" />
                  <Card.Tags tags={taxonomyTagElasticMapper(hit.vacancy_locations_name, 'vacancy_locations_name')} />
                </div>
              )}
              <div className="MetaSearchVacancyHit__employment-types">
                <Icon name="schedule" flair="outlined" />
                <div>
                  {translatedEmploymentTypes.map((type, i) => (
                    <span>
                      {type}
                      {i < translatedEmploymentTypes.length - 2 && ', '}
                      {i === translatedEmploymentTypes.length - 2 && (hit.langcode[0] === DEFAULT_LANGUAGE ? ' and ' : ' en ')}
                    </span>
                  ))}
                </div>

              </div>
            </div>
            <Icon className="Card__icon" name="arrow_forward" flair="outlined" />
          </div>

          {/* In the future, we might want to add an image here */}
        </div>

      </Card.Content>
    </Card>
  );
};

export default MetaSearchVacancyHit;
